<p-toast position="top-right" key="invoice-message"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" acceptLabel="Current Page" rejectLabel="All Pages"
                 acceptIcon="pi pi-download"
                 [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
                 [rejectIcon]="isFileDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                 [baseZIndex]="10000" acceptButtonStyleClass="p-button-secondary"
                 rejectButtonStyleClass="p-button-secondary"></p-confirmDialog>

<invoice-filters (emitFilterValue)="applyFilterToInvoices($event)" [clearFilterForm]="!clearFilter"></invoice-filters>

<div class="p-mt-2">

    <!--    Start : Invoice's Listing Card-->
    <div class="card p-p-2">


        <!--        Start: Invoice Card Header-->

        <div class="p-pt-2 p-pb-3 p-px-2 ">
            <div class="p-d-flex p-ai-center p-jc-between">

                <div class="p-d-flex p-ai-center p-jc-between p-jc-lg-start">
                    <h5 class="p-m-0 p-text-primary">Invoices & Documents</h5>
                </div>

                <div class="p-mt-3 p-mt-lg-0">
                    <div class="p-d-flex p-ai-center">
                        <div class="p-mx-3">
                            <img pRipple (click)="downloadFiles('pdf')"
                                 src="assets/branding/shared-icons/export-pdf.svg" alt=""
                                 class="fp-icon-height p-cursor">
                            <!--                                    <i class="pi pi-file-pdf" style="font-size: 1.5rem;"></i>-->
                        </div>
                        <div>
                            <img pRipple (click)="downloadFiles('excel')"
                                 src="assets/branding/shared-icons/export-excel.svg"
                                 alt="" class="fp-icon-height p-cursor">
                        </div>
                    </div>
                </div>

            </div>


            <!--            <div class="p-text-left p-text-secondary p-mt-3 p-ai-center">-->
            <!--                Showing {{displayInvoiceNumber ? 'Invoice : ' + displayInvoiceNumber : ': Invoices'}}-->
            <!--                {{displayBookingNumber ? '&nbsp;|&nbsp;' + 'Invoice for Booking : ' + '&nbsp;' + displayBookingNumber : ''}}-->
            <!--                {{displaySelectedJobType?.length > 0 ? '&nbsp;|&nbsp;' + 'JobType : ' + '&nbsp;' + displaySelectedJobType : ''}}-->
            <!--                {{displayCustRefNo?.length > 0 ? '&nbsp;|&nbsp;' + 'Customer Ref No. : ' + displayCustRefNo : ''}}-->
            <!--                {{fromDate?.toString()?.length > 0 ? '&nbsp;|&nbsp;' + 'From : ' + (fromDate | date:'dd-MM-yyyy') : ''}}-->
            <!--                {{toDate?.toString()?.length > 0 ? '&nbsp;|&nbsp;' + 'To : ' + (toDate | date:'dd-MM-yyyy') : ''}}-->
            <!--            </div>-->
        </div>

        <!--        End: Invoice Card Header-->


        <div class="divider-top">

            <!--Loader-->
            <div class="p-text-center p-mt-1">
                <div class="p-pt-5" *ngIf="isLoading" style="min-height: 20vw;">
                    <div>
                        <div class="p-text-secondary pi pi-spin pi-spinner"
                             style="font-size: 2rem"></div>
                    </div>
                    <div class="p-mt-4">
                        <h5 class="p-text-secondary">Loading Invoices & Documents !</h5>
                    </div>
                </div>

                <div class="p-d-flex p-ai-center p-jc-center" *ngIf="invoices?.content?.length === 0 && !isLoading"
                     style="min-height: 20vw;">
                    <div>
                        <button pButton pRipple label="No Invoices & Documents Found !"
                                class="p-button-text p-text-secondary"></button>
                    </div>
                </div>
            </div>

            <!--List & Card View Buttons-->
            <div *ngIf="filteredInvoices?.content.length > 0 && !isLoading"
                 class="p-d-none p-d-md-flex p-ai-center p-jc-end p-mt-2 p-pb-2 divider-bottom">
                <div class="p-text-bold p-ml-2">
                    <button pButton icon="pi pi-list" class="p-button-secondary"
                            (click)="selectedView = 0"
                            [class]="selectedView === 0 ? '' : 'p-button-text'"></button>
                </div>
                <div class="p-text-bold p-ml-2">
                    <button (click)="selectedView = 1" pButton icon="pi pi-id-card" class="p-button-secondary"
                            [class]="selectedView === 1 ? '' : 'p-button-text'"></button>
                </div>
            </div>


            <div *ngIf="filteredInvoices?.content.length > 0 && !isLoading">

                <!--TabView for Table and Cards Web View-->
                <p-tabView styleClass="p-d-none p-d-md-block" [(activeIndex)]="selectedView">
                    <!--Invoices Table View-->
                    <p-tabPanel>
                        <p-table [value]="filteredInvoices?.content" [scrollable]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pSortableColumn="shipmentType" class="p-py-3" style="width: 110px">
                                        <div class="p-d-flex p-ai-center">
                                            <div>
                                                Type
                                            </div>
                                            <div>
                                                <p-sortIcon field="shipmentType"></p-sortIcon>
                                            </div>
                                        </div>
                                    </th>

                                    <th pSortableColumn="invoiceNumber" style="width: 140px">
                                        <div class="p-d-flex p-ai-center">
                                            <div>
                                                Invoice Number
                                            </div>
                                            <div>
                                                <p-sortIcon field="invoiceNumber"></p-sortIcon>
                                            </div>
                                        </div>
                                    </th>

                                    <th pSortableColumn="invoiceDate" style="width: 120px">
                                        <div class="p-d-flex p-ai-center">
                                            <div>
                                                Invoice Date
                                            </div>
                                            <div>
                                                <p-sortIcon field="invoiceDate"></p-sortIcon>
                                            </div>
                                        </div>
                                    </th>

                                    <th pSortableColumn="bookingId" style="width: 140px">
                                        <div class="p-d-flex p-ai-center">
                                            <div>
                                                Booking Number
                                            </div>
                                            <div>
                                                <p-sortIcon field="bookingId"></p-sortIcon>
                                            </div>
                                        </div>
                                    </th>

                                    <th pSortableColumn="customerReferenceNumber" style="width: 170px">
                                        <div class="p-d-flex p-ai-center">
                                            <div>
                                                Customer Reference Number
                                            </div>
                                            <div>
                                                <p-sortIcon field="customerReferenceNumber"></p-sortIcon>
                                            </div>
                                        </div>
                                    </th>

                                    <th pSortableColumn="transportDocuments" style="width: 150px">
                                        <div class="p-d-flex p-ai-center">
                                            <div>
                                                Transport Document
                                            </div>
                                            <div>
                                                <p-sortIcon field="transportDocuments"></p-sortIcon>
                                            </div>
                                        </div>
                                    </th>

                                    <th pSortableColumn="billTo" style="width: 130px">
                                        <div class="p-d-flex p-ai-center">
                                            <div>
                                                Bill To
                                            </div>
                                            <div>
                                                <p-sortIcon field="billTo"></p-sortIcon>
                                            </div>
                                        </div>
                                    </th>

                                    <th pSortableColumn="formattedInvoiceAmount" style="width: 130px">
                                        <div class="p-d-flex p-ai-center">
                                            <div>
                                                Invoice Amount
                                            </div>
                                            <div>
                                                <p-sortIcon field="formattedInvoiceAmount"></p-sortIcon>
                                            </div>
                                        </div>
                                    </th>

                                    <th style="width: 30px">
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-invoice>
                                <tr class="divider-bottom">
                                    <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                        style="width: 110px" class="p-py-4"
                                        [ngClass]="getColourStatus(invoice?.shipmentType)">{{invoice?.shipmentType ? invoice?.shipmentType : '-'}}</td>
                                    <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                        (click)="navigateToDocuments(invoice)" style="width: 140px"
                                        class="p-field-hover p-text-bold p-cursor">{{invoice?.invoiceNumber ? invoice?.invoiceNumber : '-'}}</td>
                                    <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                        style="width: 120px">{{invoice?.invoiceDate ? (invoice?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}</td>
                                    <td [class.p-cursor]="invoice?.bookingsCount > 0"
                                        [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                        (mouseenter)="invoice.showMultipleBookings = true"
                                        (mouseleave)="invoice.showMultipleBookings = false"
                                        style="width: 140px">
                                        <div
                                                class="p-d-flex p-ai-center p-jc-start">
                                            <div>
                                                {{invoice?.bookingId ? invoice?.bookingId : '-'}}
                                            </div>

                                            <div class="p-ml-2"
                                                 *ngIf="invoice?.bookingsCount > 0">
                                                <p-badge
                                                        [value]="'+'+invoice?.bookingsCount"></p-badge>

                                            </div>
                                        </div>
                                        <div *ngIf="invoice.showMultipleBookings">
                                            <div class="p-mt-2 p-text-secondary"
                                                 *ngFor="let bookingNumbers of invoice.multipleBookingNumbers?.split(',')">
                                                {{bookingNumbers}}
                                            </div>
                                        </div>

                                    </td>
                                    <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                        style="width: 170px">{{invoice?.customerReferenceNumber ? invoice?.customerReferenceNumber : '-'}}</td>
                                    <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                        style="width: 150px">{{invoice?.transportDocuments ? invoice?.transportDocuments : '-'}}</td>
                                    <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                        style="width: 130px">{{invoice?.billTo ? invoice?.billTo : '-'}}</td>
                                    <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                        style="width: 130px">{{invoice?.formattedInvoiceAmount ? invoice?.formattedInvoiceAmount : '-'}}</td>
                                    <td style="width: 30px"><img class="p-cursor"
                                                                 src="assets/branding/shared-icons/view.svg" alt=""
                                                                 style="height: 1.3rem;"
                                                                 (click)="navigateToDocuments(invoice)"></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </p-tabPanel>

                    <!--Invoices Card View-->
                    <p-tabPanel>
                        <div class="p-grid">
                            <div class="p-col-12 p-md-6 p-lg-6 p-xl-4"
                                 *ngFor="let invoice of filteredInvoices?.content">
                                <invoices-card (emitActions)="handleCardViewActions($event)"
                                               [invoice]="invoice"></invoices-card>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </div>

            <!--Invoice Card Mobile View-->
            <div class="p-d-block p-d-md-none">
                <div class="p-grid">
                    <div class="p-col-12 p-md-6 p-lg-6 p-xl-4" *ngFor="let invoice of filteredInvoices?.content">
                        <invoices-card (emitActions)="handleCardViewActions($event)"
                                       [invoice]="invoice"></invoices-card>
                    </div>
                </div>
            </div>

        </div>


        <!--Paginator-->
        <div *ngIf="filteredInvoices?.content?.length > 0" class="p-mt-2">
            <p-paginator #pagination (onPageChange)="paginateFilteredInvoices($event)" [rows]="10"
                         [totalRecords]="filteredInvoices?.totalElements"></p-paginator>
        </div>


    </div>

</div>
